import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight, CheckCircle } from 'lucide-react';
import FilloutButton from '@/components/FilloutButton';

const FilloutCTASection = () => {
  const { t } = useTranslation('fillout');

  const benefitsData = t('cta.benefits', { returnObjects: true });
  const benefits = Array.isArray(benefitsData) ? benefitsData as string[] : [];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-primary/10 via-background to-accent/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="max-w-4xl mx-auto overflow-hidden border-primary/20 shadow-2xl bg-gradient-to-br from-background/95 to-background/90 backdrop-blur-lg">
          <CardContent className="p-8 sm:p-12 lg:p-16">
            <div className="text-center space-y-6 sm:space-y-8">
              <div className="space-y-4">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold">
                  {t('cta.title')}
                </h2>
                <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto">
                  {t('cta.subtitle')}
                </p>
              </div>

              {/* Benefits */}
              <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center gap-3 text-left">
                    <CheckCircle className="w-5 h-5 text-primary flex-shrink-0" />
                    <span className="text-sm sm:text-base text-muted-foreground">{benefit}</span>
                  </div>
                ))}
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <FilloutButton className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-4 text-lg font-semibold rounded-xl group">
                  {t('cta.primaryButton')}
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </FilloutButton>
                
                <FilloutButton 
                  variant="outline"
                  className="px-8 py-4 text-lg font-semibold rounded-xl border-2 border-primary/20 hover:border-primary/40"
                >
                  {t('cta.secondaryButton')}
                </FilloutButton>
              </div>

              {/* Trust Signal */}
              <p className="text-sm text-muted-foreground">
                {t('cta.trustSignal')}
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default FilloutCTASection;